// Copyright (c) 2021 Deere & Company

import actions from '../actions-list';
import {sortCollection} from '../../../shared/services/collections';

export const initializeList = (dealers, searchFilters) => ({
    data: sortCollection(searchFilters.sortBy, searchFilters.sortDirection, dealers),
    type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/action-creators/mass-labor-rate-request-filtered.js